import { render, staticRenderFns } from "./FxRatesComponent.vue?vue&type=template&id=35ba1348&scoped=true"
import script from "./FxRatesComponent.vue?vue&type=script&lang=js"
export * from "./FxRatesComponent.vue?vue&type=script&lang=js"
import style0 from "./FxRatesComponent.vue?vue&type=style&index=0&id=35ba1348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba1348",
  null
  
)

export default component.exports